import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { MyThunkDispatch, RootState } from 'store';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import LoginSso from 'screens/components/LoginSso';
import * as loginSsoService from 'services/loginSsoService';
import { getCompanyConfigurationFromDomain } from 'actions/companyConfiguration';

const LoginSsoContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  dispatch(getCompanyConfigurationFromDomain(`${window.location.protocol}//${window.location.host}/corporate`));
  const companyId = useSelector((state: RootState) => state.companyConfiguration.configuration?.companyId) ?? '';
  
  const handleSubmit = async (username: string, password: string) => {
    setLoading(true);
    
    try {
      const response = await loginSsoService.handleLoginSso(username, password, companyId);
      history.push(`/corporate/auth/${response.sessionToken}`);
    } catch (error) {
      
      toast.add({ type: 'danger', message: t('loginSso.invalidCredentials') });
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginSso loading={isLoading} onLogin={(username: string, password: string) => handleSubmit(username, password)} />
  );
};

export default LoginSsoContainer;

